import { render, staticRenderFns } from "./mutedPop.vue?vue&type=template&id=484ede38&scoped=true"
import script from "./mutedPop.vue?vue&type=script&lang=js"
export * from "./mutedPop.vue?vue&type=script&lang=js"
import style0 from "./mutedPop.vue?vue&type=style&index=0&id=484ede38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ede38",
  null
  
)

export default component.exports